import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Process } from '../../components/process/process';
import { ProcessForm } from './production-site-split-types';
import { useProductionSiteSplit } from './production-site-split-hook';
import { TranslationKeys } from '../../enums';

const useStyles = makeStyles(() =>
  createStyles({
    loaderWrapper: {
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
      padding: '10px',
    },
  })
);

export function ProductionSiteSplit() {
  const classes = useStyles();

  const { steps, isLoading } = useProductionSiteSplit();

  return isLoading ? (
    <div className={classes.loaderWrapper}>
      <CircularProgress />
    </div>
  ) : (
    <Process<ProcessForm>
      title="Rozdělení průmyslového místa"
      steps={steps}
      translationKey={TranslationKeys.PRODUCTION_SITE_SPLIT}
    />
  );
}
